'use client';

/* eslint-disable prettier/prettier */
var translations = {
    'Job hidden': 'Đã ẩn việc làm',
    'You will not see this job on the search page.': 'Bạn sẽ không nhìn thấy việc làm này trên trang tìm kiếm.',
    'Undo': 'Hoàn tác',
    'Jobs You Will Love': 'Việc Làm Bạn Sẽ Thích',
    'Apply All Jobs': 'Nộp Đơn Tất Cả',
    'apply-multiple-jobs': 'ung-tuyen-nhieu-viec-lam',
};

export { translations as default };
//# sourceMappingURL=translations.js.map
